// extracted by mini-css-extract-plugin
export default {"container":"d27dgBi5VHwomdyxSF9g","title":"Rt1hWp2X7wovVlMVfdfg","timer":"QDpZ276pEd7t8peZYCza","buttons":"ANyKkTUFRkFFfa2fmCr0","resumeButton":"PNXln0S8T9Fq8cFpHzKF"};